<label class="input input-radio radio-option" [class.error]="error" [class.disabled]="disabled">
  <input
    type="radio"
    [attr.name]="name || id"
    [checked]="value === radioValue"
    [disabled]="disabled"
    (change)="select()"
    (blur)="onBlur($event)">
  @if (label) {
    <span>{{ label }}</span>
  }
  @if (showMessages) {
    <div class="messages">
      @for (error of errorMessages; track error) {
        <small class="error">{{ error }}</small>
      }
      <ng-content></ng-content>
    </div>
  }
</label>
